import { categories } from '@/mocks/categories';

export default function HeroSection() {
  return (
    <section className="relative min-h-[600px] md:min-h-[720px] flex items-center justify-center overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Vibrant%20colorful%20streetwear%20fashion%20flat%20lay%20with%20sneakers%20hoodies%20caps%20bags%20and%20accessories%20scattered%20on%20warm%20terracotta%20background%2C%20top%20down%20view%2C%20soft%20editorial%20studio%20lighting%2C%20high%20detail%20fabric%20textures%2C%20bold%20modern%20commercial%20aesthetic&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape&nocache=true"
          alt="AllChinaBuy Spreadsheet"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-4 md:px-8 lg:px-12 text-center pt-20">
        <span className="inline-block px-4 py-1.5 bg-white/10 backdrop-blur-sm text-white/90 text-xs font-semibold tracking-wider uppercase rounded-full border border-white/20 mb-6">
          Trusted by 10,000+ Buyers Worldwide
        </span>

        <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-4xl mx-auto">
          AllChinaBuy Spreadsheet — The Only Product List You Actually Need
        </h1>

        <p className="mt-5 text-lg md:text-xl text-white/80 max-w-2xl mx-auto leading-relaxed">
          Stop scrolling endlessly. Every product is pre-checked, price-tagged, and one click away from your cart. We did the research so you don't have to.
        </p>

        <div className="mt-8 flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 text-white font-semibold rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
          >
            Shop the Full Spreadsheet Now
            <i className="ri-external-link-line" />
          </a>
          <a
            href="#guides"
            className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 backdrop-blur-sm text-white font-semibold rounded-lg border border-white/20 hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            Browse Buying Guides
            <i className="ri-arrow-down-line" />
          </a>
        </div>

        <p className="mt-4 text-sm text-white/50">
          100+ products across 13 categories. Updated daily. Free to browse.
        </p>

        {/* Category dropdown style buttons */}
        <div className="mt-10">
          <p className="text-sm text-white/60 mb-4">Browse Categories</p>
          <div className="flex flex-wrap items-center justify-center gap-2 max-w-3xl mx-auto">
            {categories.slice(0, 8).map((cat) => (
              <a
                key={cat.name}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 bg-white/10 backdrop-blur-sm text-white text-sm font-medium rounded-full border border-white/15 hover:bg-white/20 transition-colors whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 bg-primary-500 text-white text-sm font-medium rounded-full hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              + {categories.length - 8} More
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}